import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';

import { Input } from '@/components/form';
import ResourceForm from '@/components/resources/form';
import View from '@/components/view';

import Contents from './contents';

const ConditionTypeForm = ({ match }) => {
  return (
    <View>
      <ResourceForm resource="Cookie" id={match.params.id} initialValues={{ name: {}, alias: '', contents: [] }}>
        {({ submitting, renderActions }) => (
          <>
            <Card>
              <CardBody className={submitting ? 'loading' : ''}>
                <Row>
                  <Col lg={6}>
                    <Input name="name" />
                  </Col>
                  <Col lg={6}>
                    <Input name="alias" />
                  </Col>
                </Row>
                <Contents />
              </CardBody>
            </Card>
            <div className="mt-4 mb-4">{renderActions()}</div>
          </>
        )}
      </ResourceForm>
    </View>
  );
};

ConditionTypeForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  }).isRequired
};

export default ConditionTypeForm;
